/* eslint-disable @typescript-eslint/no-explicit-any */
/*
 * RetargetMouseScroll TypeScript Library v0.0.2
 * 2009-07-30
 * By Eli Grey, http://eligrey.com
 *
 * http://github.com/eligrey/RetargetMouseScroll/tree/master
 *
 * Licensed under the MIT License
 *   See https://github.com/eligrey/RetargetMouseScroll/blob/master/LICENSE.md
 */

/*! @source http://purl.eligrey.com/github/RetargetMouseScroll/blob/master/
 *          RetargetMouseScroll.js
 */

type ScrollEvent = MouseEvent & {
  detail?: number;
  wheelDelta?: number;
  wheelDeltaX?: number;
  axis?: number;
  HORIZONTAL_AXIS?: number;
};

if (typeof (window as any).RetargetMouseScroll !== "function") {
  (function () {
    const mouseScrollEvents = ["DOMMouseScroll", "mousewheel"];

    function handleScroll(
      evt: ScrollEvent,
      target: HTMLElement | Window,
      preventDefault: boolean,
      scrollMultiplier?: number,
    ) {
      if (preventDefault) {
        if (evt.preventDefault) {
          evt.preventDefault();
        } else {
          (evt as any).returnValue = false;
        }
      }

      let scrollAmount = evt.detail || -evt.wheelDelta! / 40; // convert wheelData to lines
      scrollAmount *= 2; // convert lines to pixels

      if (typeof scrollMultiplier === "number" && !isNaN(scrollMultiplier)) {
        scrollAmount *= scrollMultiplier;
      }

      if (evt.wheelDeltaX || ("axis" in evt && "HORIZONTAL_AXIS" in evt && evt.axis === evt.HORIZONTAL_AXIS)) {
        // horizontal scroll
        if ("scrollBy" in target) {
          (target as HTMLElement).scrollBy({ left: scrollAmount, behavior: "auto" });
        } else {
          (target as HTMLElement).scrollLeft += scrollAmount;
        }
      } else {
        // vertical scroll
        if ("scrollBy" in target) {
          (target as HTMLElement).scrollBy({ top: scrollAmount, behavior: "auto" });
        } else {
          (target as HTMLElement).scrollTop += scrollAmount;
        }
      }
    }

    (window as any).RetargetMouseScroll = function (
      elem: HTMLElement | Document | null,
      target: HTMLElement | Window | null,
      preventDefault: boolean = true,
      scrollMultiplier?: number,
      preventRetarget?: null | ((evt: ScrollEvent) => boolean),
    ) {
      if (!elem) elem = document;
      if (!target) target = window;

      if (typeof preventRetarget !== "function") preventRetarget = null;

      let addListener: any;
      let removeListener: any;
      let restoreFn: (() => void) | undefined;

      // eslint-disable-next-line func-style
      const handler = function (evt: ScrollEvent) {
        evt = evt || (window.event as ScrollEvent);

        // @ts-expect-error shhhhhht
        if (preventRetarget && preventRetarget.call(this, evt)) return;
        handleScroll(evt, target!, preventDefault, scrollMultiplier);
      };

      if ((addListener = (elem as any).addEventListener)) {
        addListener.call(elem, mouseScrollEvents[0], handler, false);
        addListener.call(elem, mouseScrollEvents[1], handler, false);
      } else if ((addListener = (elem as any).attachEvent)) {
        addListener.call(elem, "on" + mouseScrollEvents[1], handler);
      }

      if ((removeListener = (elem as any).removeEventListener)) {
        restoreFn = function () {
          removeListener.call(elem, mouseScrollEvents[0], handler, false);
          removeListener.call(elem, mouseScrollEvents[1], handler, false);
        };
      } else if ((removeListener = (elem as any).detachEvent)) {
        restoreFn = function () {
          removeListener.call(elem, "on" + mouseScrollEvents[1], handler);
        };
      }

      return {
        restore: restoreFn,
      };
    };
  })();
}
